import _ from 'lodash';
import React, { PureComponent } from 'react';

import { trackAnalyticsEvent } from '@eb/site-analytics';
import transform from '../transform';
import defaultSettings from './settings';
import userSettings from './userSettings';

import {
    PACKAGE_TWO,
    PACKAGE_TWO_PAGE,
    PACKAGE_PATHS,
    PACKAGE_TWO_PATH,
} from '../../constants/main';
import {
    PROFESSIONAL_CTA_ACTION,
    PROFESSIONAL_STICKY_CTA_ACTION,
    PACKAGE_NAVIGATION_ACTION,
    GA_CHOOSE_PACKAGE,
    GA_LEARN_MORE_CLICKED,
    GA_TOP_LABEL,
    GA_BOTTOM_LABEL,
    GA_P1_LABEL,
    GA_P3_LABEL,
} from '../../constants/analytics';
import { handleLoadDriftChatbot, loadCrazyEgg } from '../utils';

import PageTitle from '../../components/PageTitle';
import FeaturesExpansion from '../../components/FeaturesExpansion';
import Testimonials from '../../components/Testimonials';
import MainHeader from '../../components/MainHeader';
import ThreeColumnFeatures from '../../components/ThreeColumnFeatures';
import TwoColumnFeatures from '../../components/TwoColumnFeatures';
import ActionBanner from '../../components/ActionBanner';

export default class PackageTwoPage extends PureComponent {
    componentDidMount() {
        loadCrazyEgg();
    }

    render() {
        const {
            activeScopeUserId,
            locale,
            isAuthenticated,
            goToPricing,
            goToPackageOne,
            goToPackageThree,
            goToPackageComparison,
            showLowAtvUi,
            redirectToProfessional,
            assortmentsPricing,
            assortmentsTax,
            userPlan,
            packageTitles,
        } = this.props;
        const tabActions = [
            goToPackageOne.bind(null, PACKAGE_NAVIGATION_ACTION, GA_P1_LABEL),
            _.noop,
            goToPackageThree.bind(null, PACKAGE_NAVIGATION_ACTION, GA_P3_LABEL),
        ];
        const {
            bottomBanner,
            featureListOne,
            featureListTwo,
            featureListThree,
            testimonials,
            featuresExpansion,
            mainHeader,
        } = transform({
            locale,
            isAuthenticated,
            defaultSettings,
            page: PACKAGE_TWO_PAGE,
            userSettings,
            userPlan,
        });

        trackAnalyticsEvent({
            action: GA_LEARN_MORE_CLICKED,
            category: GA_CHOOSE_PACKAGE,
            dimensions: {
                userId: activeScopeUserId,
                planLearnMore: PACKAGE_TWO_PATH,
                locale,
            },
        });

        return (
            <div>
                <PageTitle title={packageTitles.professional} />
                <MainHeader
                    {...mainHeader}
                    price={assortmentsPricing[PACKAGE_TWO]}
                    taxLabel={assortmentsTax[PACKAGE_TWO]}
                    tabActions={tabActions}
                    tabPaths={PACKAGE_PATHS}
                    hidePricing={showLowAtvUi}
                    onClick={redirectToProfessional.bind(
                        null,
                        PROFESSIONAL_CTA_ACTION,
                        GA_TOP_LABEL,
                    )}
                    onStickyClick={redirectToProfessional.bind(
                        null,
                        PROFESSIONAL_STICKY_CTA_ACTION,
                    )}
                    pricingCalloutAction={goToPricing.bind(
                        null,
                        null,
                        PACKAGE_TWO,
                    )}
                />
                <ThreeColumnFeatures
                    {...featureListOne}
                    removeHorizontalPadding={true}
                />
                <TwoColumnFeatures {...featureListTwo} />
                <TwoColumnFeatures
                    {...featureListThree}
                    reverseHorizontal={true}
                />
                <Testimonials {...testimonials} />
                <FeaturesExpansion
                    {...featuresExpansion}
                    onClick={goToPackageComparison.bind(null, PACKAGE_TWO)}
                />
                <ActionBanner
                    {...bottomBanner}
                    onClick={redirectToProfessional.bind(
                        null,
                        PROFESSIONAL_CTA_ACTION,
                        GA_BOTTOM_LABEL,
                    )}
                />
            </div>
        );
    }
}
